window.initSelect = function () {
    let $select = $('.js-select');
    window.$select = $select;
    $select.select2({
        dropdownAutoWidth: true,
        containerCssClass: 'select',
        dropdownCssClass: 'no-input'
    }).on('change', function (e) {
        const labelTxt = $(e.target).attr('data-label');
        if (!labelTxt) return;
        const $selectionBox = $(e.target).siblings('.select2').find('.select2-selection__rendered');
        const labelTemplate = `<span class="select-label">${labelTxt}:&nbsp;</span>`;
        $selectionBox.prepend(labelTemplate);
    }).trigger('change');

    $('.js-select-default')
        .select2({
            dropdownAutoWidth: true,
            containerCssClass: 'select',
            dropdownCssClass: 'no-input'
        })

    $('.js-select-search')
        .select2({
            dropdownAutoWidth: false,
            containerCssClass: 'select',
        })
        .on('change', function (e) {
            const labelTxt = $(e.target).attr('data-label');
            if (!labelTxt) return;
            const $selectionBox = $(e.target).siblings('.select2').find('.select2-selection__rendered');
            const labelTemplate = `<span class="select-label">${labelTxt}:&nbsp;</span>`;
            $selectionBox.prepend(labelTemplate);
        })
        .trigger('change');
}

$(function () {
    initSelect();
});
